/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionError } from './ActionError';
import type { ActionOutputs } from './ActionOutputs';
/**
 * TSOA-compatible workflow step execution.
 */
export type TCWorkflowStepExecution = {
    error?: ActionError;
    createdAt: string;
    tenantId: string;
    status: TCWorkflowStepExecution.status;
    workflowId: string;
    toolName: string;
    executionId: string;
    outputs?: ActionOutputs;
    parentExecution?: {
        stepId: string;
        id: string;
    };
    rootExecutionId: string;
    stepId: string;
    childExecution?: {
        id: string;
    };
    version: (string | number);
};
export namespace TCWorkflowStepExecution {
    export enum status {
        COMPLETED = 'completed',
        FAILED = 'failed',
    }
}

